export default __webpack_public_path__ + "static/media/tailwind.aeeb64f5.png";